export default __webpack_public_path__ + "static/media/3.10.e30e0634.mp3";